export const MISSING_FIELD_ERROR_CODE = 'field_missing_in_schemas';

//# sourceMappingURL=GqlError.js.map